<template>
  <div class="viq-msg-loading">
    <div class="viq-msg-loading__dots">
      <span class="viq-msg-loading__dot" />
      <span class="viq-msg-loading__dot" />
      <span class="viq-msg-loading__dot" />
    </div>
    <span class="viq-msg-loading__text">Generating answer…</span>
  </div>
</template>

<script>
export default {
  name: "ViqMessageLoading",
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-msg-loading {
  display: inline-flex;
  align-items: center;
  gap: $viq-space-sm;
  padding: $viq-space-xs 0;

  &__dots {
    display: flex;
    align-items: center;
    gap: 3px;
  }

  &__dot {
    width: 6px;
    height: 6px;
    background: $viq-accent;
    border-radius: 50%;
    animation: bounce 1.4s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.15s;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }

  &__text {
    font-size: $viq-font-xs;
    color: $viq-text-muted;
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
